import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MpfContactBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@mpf/contact/feature","featureId":"mpf-contact"},
      bundledItemModels: ["WaitingListItem", "DemoRequestItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users'],
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfContactFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfContactFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfContactBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfContactBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {};
  }
}